 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-09d6dff3":"e2be5272","chunk-0b5730fc":"51dbdf57","chunk-0bd69fa0":"1175587a","chunk-109e4a0e":"71c80b25","chunk-125d9736":"2da1ddf7","chunk-17f70de9":"a8f3d5f3","chunk-18743bef":"ae28f605","chunk-19e448bb":"2af9bef8","chunk-1a324f0c":"bce560f0","chunk-1b247cbd":"5d5d1219","chunk-1b6beab1":"ef1f9e83","chunk-1bc8f52c":"4ea25d28","chunk-1ce26ccc":"de2d1501","chunk-20452b85":"51f9b93f","chunk-208c2446":"d5817f30","chunk-20c5e9c0":"1a348431","chunk-21ca5f48":"493cb28c","chunk-2349b137":"6d90d918","chunk-28466fc8":"bf060379","chunk-2a54b88e":"b4d3c34f","chunk-2d0b345c":"0514d74c","chunk-2d0bce05":"d24c56b1","chunk-2d0c77ad":"4a7a3d80","chunk-2d0c8f6d":"c5dc618e","chunk-2d0c91d2":"1f18730e","chunk-2d0cb6e8":"34570036","chunk-2d0cbb33":"ff251906","chunk-2d0d0818":"30317256","chunk-2d0da2ea":"568a1e6c","chunk-2d0da6a8":"cf7402c4","chunk-2d0dace4":"4e6eb0d5","chunk-2d0e95df":"1856eebd","chunk-2d0e9d6e":"0a0cd2d9","chunk-2d210c28":"49e6e0b9","chunk-2d212fd8":"12520ef9","chunk-2d217361":"b7b706cc","chunk-2d2253ae":"454d9540","chunk-2ecfd031":"56490411","chunk-24b425c8":"05314d1b","chunk-2b02de32":"94437cfd","chunk-7f881edd":"f096bd78","chunk-303254b2":"5e6c50fa","chunk-347ebcac":"23659b97","chunk-354b2aa8":"399000db","chunk-35a579a2":"8846fba2","chunk-398cbac2":"b4c972ef","chunk-3b7d8115":"bbb43fb0","chunk-3d675996":"bb2d9205","chunk-3dbd8674":"7956cbf9","chunk-44498110":"2f14fa0f","chunk-44a3da96":"35c49c59","chunk-4553975f":"94f9ea9d","chunk-49117393":"413a47c5","chunk-4b380372":"72ff9458","chunk-4b8b91e4":"32e757d2","chunk-4d17f324":"128bd18f","chunk-4d36cfbd":"d66b4893","chunk-500f1185":"99c40882","chunk-507148a8":"1c8f4654","chunk-51bf7232":"38916f15","chunk-545326c0":"a61ab69f","chunk-54f07aba":"73040396","chunk-56cc7a73":"06062492","chunk-56dec1a4":"76848a40","chunk-5a84305a":"f67ceaec","chunk-5fd9ef88":"0de2f7d4","chunk-609e28f6":"e3d41869","chunk-646bac48":"49caec22","chunk-66173c80":"15ad9579","chunk-66ab3fd1":"2c2704f1","chunk-67147130":"d76637ed","chunk-67db813b":"3cdd19b7","chunk-6ac44d3d":"4c98f3af","chunk-6cd8d239":"03ec7c75","chunk-4dc0318a":"c58e24f5","chunk-c154174a":"adf75d25","chunk-6d7092e8":"93e02f32","chunk-6e6dcf96":"9c096fb3","chunk-6f384fdc":"70cf79a9","chunk-6f5955ca":"4a66d607","chunk-00357acc":"a0376606","chunk-17d2ea76":"ffe29242","chunk-2d20918a":"a940d2a4","chunk-31e3aaf3":"14287546","chunk-3635a07f":"39f0f073","chunk-4b330e93":"f4946f2d","chunk-4e2546e6":"3d245fef","chunk-540eb546":"e8f9c0f9","chunk-59d91b22":"41fd2e05","chunk-844aa964":"c889624a","chunk-8f099ab8":"426e827b","chunk-9fe4383e":"24f98604","chunk-b92141c0":"c8da9be3","chunk-dd2b1d46":"8dfc09bd","chunk-6f60227b":"b0b28a8b","chunk-70e35ebc":"62f67c50","chunk-72addada":"36a1f0c1","chunk-73e9d5f2":"980fc355","chunk-744c292d":"60a657a5","chunk-7459c046":"15b887e4","chunk-7a585770":"f81ed6b2","chunk-7e16cd9d":"612e98a4","chunk-7ed8b0ce":"5f1b016e","chunk-7f66c91b":"669c5155","chunk-7f706172":"8b5b546e","chunk-8039543e":"34d698f3","chunk-982b6af2":"cc5a1401","chunk-99bcc778":"379c0422","chunk-9ac5abb0":"d67bc390","chunk-9dcfc230":"df7b0cf0","chunk-9eba3760":"a6f93306","chunk-a39ff88a":"82b6ad8e","chunk-a46f779c":"27a0ce15","chunk-ac7c3ac8":"6efb5a43","chunk-adc2bb66":"23450c07","chunk-b81bcb8a":"ede8862e","chunk-bb042eec":"e7c42ffb","chunk-bb9055bc":"7f171b61","chunk-bfb322dc":"a1f1f007","chunk-c6b29aa4":"8372b3ca","chunk-ca4f0720":"e116ffa7","chunk-cf78b932":"158af654","chunk-d2175d8a":"b24708f6","chunk-e1a6d904":"68e45e74","chunk-e2b49012":"cba424d0","chunk-ed77b080":"cb493b9c","chunk-faf9c3f6":"4f24e76b","fail":"e05990dc","lang-en-US":"46fcb424","lang-en-US-setting":"fcce41ed","lang-vi":"d31eeaf9","lang-vi-setting":"8f8c24a9","user":"25ec6915"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0b5730fc":1,"chunk-0bd69fa0":1,"chunk-17f70de9":1,"chunk-18743bef":1,"chunk-19e448bb":1,"chunk-1b6beab1":1,"chunk-1ce26ccc":1,"chunk-20c5e9c0":1,"chunk-21ca5f48":1,"chunk-24b425c8":1,"chunk-354b2aa8":1,"chunk-398cbac2":1,"chunk-44498110":1,"chunk-4b8b91e4":1,"chunk-4d36cfbd":1,"chunk-54f07aba":1,"chunk-56cc7a73":1,"chunk-56dec1a4":1,"chunk-609e28f6":1,"chunk-66ab3fd1":1,"chunk-6cd8d239":1,"chunk-4dc0318a":1,"chunk-c154174a":1,"chunk-72addada":1,"chunk-744c292d":1,"chunk-7459c046":1,"chunk-7a585770":1,"chunk-7ed8b0ce":1,"chunk-7f66c91b":1,"chunk-7f706172":1,"chunk-8039543e":1,"chunk-9dcfc230":1,"chunk-a39ff88a":1,"chunk-a46f779c":1,"chunk-bb042eec":1,"chunk-bfb322dc":1,"chunk-d2175d8a":1,"chunk-e2b49012":1,"chunk-faf9c3f6":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-09d6dff3":"31d6cfe0","chunk-0b5730fc":"0317eb89","chunk-0bd69fa0":"34d24fb6","chunk-109e4a0e":"31d6cfe0","chunk-125d9736":"31d6cfe0","chunk-17f70de9":"36b7e556","chunk-18743bef":"4f477acb","chunk-19e448bb":"03ad528b","chunk-1a324f0c":"31d6cfe0","chunk-1b247cbd":"31d6cfe0","chunk-1b6beab1":"128ba776","chunk-1bc8f52c":"31d6cfe0","chunk-1ce26ccc":"941a5711","chunk-20452b85":"31d6cfe0","chunk-208c2446":"31d6cfe0","chunk-20c5e9c0":"437705e3","chunk-21ca5f48":"73ead4c7","chunk-2349b137":"31d6cfe0","chunk-28466fc8":"31d6cfe0","chunk-2a54b88e":"31d6cfe0","chunk-2d0b345c":"31d6cfe0","chunk-2d0bce05":"31d6cfe0","chunk-2d0c77ad":"31d6cfe0","chunk-2d0c8f6d":"31d6cfe0","chunk-2d0c91d2":"31d6cfe0","chunk-2d0cb6e8":"31d6cfe0","chunk-2d0cbb33":"31d6cfe0","chunk-2d0d0818":"31d6cfe0","chunk-2d0da2ea":"31d6cfe0","chunk-2d0da6a8":"31d6cfe0","chunk-2d0dace4":"31d6cfe0","chunk-2d0e95df":"31d6cfe0","chunk-2d0e9d6e":"31d6cfe0","chunk-2d210c28":"31d6cfe0","chunk-2d212fd8":"31d6cfe0","chunk-2d217361":"31d6cfe0","chunk-2d2253ae":"31d6cfe0","chunk-2ecfd031":"31d6cfe0","chunk-24b425c8":"cffa522e","chunk-2b02de32":"31d6cfe0","chunk-7f881edd":"31d6cfe0","chunk-303254b2":"31d6cfe0","chunk-347ebcac":"31d6cfe0","chunk-354b2aa8":"1b938cc5","chunk-35a579a2":"31d6cfe0","chunk-398cbac2":"73ead4c7","chunk-3b7d8115":"31d6cfe0","chunk-3d675996":"31d6cfe0","chunk-3dbd8674":"31d6cfe0","chunk-44498110":"bdccc921","chunk-44a3da96":"31d6cfe0","chunk-4553975f":"31d6cfe0","chunk-49117393":"31d6cfe0","chunk-4b380372":"31d6cfe0","chunk-4b8b91e4":"7e6ae09f","chunk-4d17f324":"31d6cfe0","chunk-4d36cfbd":"826d82f5","chunk-500f1185":"31d6cfe0","chunk-507148a8":"31d6cfe0","chunk-51bf7232":"31d6cfe0","chunk-545326c0":"31d6cfe0","chunk-54f07aba":"0e07c69f","chunk-56cc7a73":"817f0b53","chunk-56dec1a4":"8a41c503","chunk-5a84305a":"31d6cfe0","chunk-5fd9ef88":"31d6cfe0","chunk-609e28f6":"4e3f5168","chunk-646bac48":"31d6cfe0","chunk-66173c80":"31d6cfe0","chunk-66ab3fd1":"f84e2b27","chunk-67147130":"31d6cfe0","chunk-67db813b":"31d6cfe0","chunk-6ac44d3d":"31d6cfe0","chunk-6cd8d239":"5748a23b","chunk-4dc0318a":"4aa6b438","chunk-c154174a":"e3a93821","chunk-6d7092e8":"31d6cfe0","chunk-6e6dcf96":"31d6cfe0","chunk-6f384fdc":"31d6cfe0","chunk-6f5955ca":"31d6cfe0","chunk-00357acc":"31d6cfe0","chunk-17d2ea76":"31d6cfe0","chunk-2d20918a":"31d6cfe0","chunk-31e3aaf3":"31d6cfe0","chunk-3635a07f":"31d6cfe0","chunk-4b330e93":"31d6cfe0","chunk-4e2546e6":"31d6cfe0","chunk-540eb546":"31d6cfe0","chunk-59d91b22":"31d6cfe0","chunk-844aa964":"31d6cfe0","chunk-8f099ab8":"31d6cfe0","chunk-9fe4383e":"31d6cfe0","chunk-b92141c0":"31d6cfe0","chunk-dd2b1d46":"31d6cfe0","chunk-6f60227b":"31d6cfe0","chunk-70e35ebc":"31d6cfe0","chunk-72addada":"3f66f441","chunk-73e9d5f2":"31d6cfe0","chunk-744c292d":"3aac4123","chunk-7459c046":"3426b597","chunk-7a585770":"323a341f","chunk-7e16cd9d":"31d6cfe0","chunk-7ed8b0ce":"8a41c503","chunk-7f66c91b":"66183a72","chunk-7f706172":"11711f41","chunk-8039543e":"a60f24a6","chunk-982b6af2":"31d6cfe0","chunk-99bcc778":"31d6cfe0","chunk-9ac5abb0":"31d6cfe0","chunk-9dcfc230":"2ffe332b","chunk-9eba3760":"31d6cfe0","chunk-a39ff88a":"f336c531","chunk-a46f779c":"7e6ae09f","chunk-ac7c3ac8":"31d6cfe0","chunk-adc2bb66":"31d6cfe0","chunk-b81bcb8a":"31d6cfe0","chunk-bb042eec":"af557729","chunk-bb9055bc":"31d6cfe0","chunk-bfb322dc":"f5944d5c","chunk-c6b29aa4":"31d6cfe0","chunk-ca4f0720":"31d6cfe0","chunk-cf78b932":"31d6cfe0","chunk-d2175d8a":"9a85fade","chunk-e1a6d904":"31d6cfe0","chunk-e2b49012":"c78a3dfe","chunk-ed77b080":"31d6cfe0","chunk-faf9c3f6":"36527024","fail":"31d6cfe0","lang-en-US":"31d6cfe0","lang-en-US-setting":"31d6cfe0","lang-vi":"31d6cfe0","lang-vi-setting":"31d6cfe0","user":"20577de5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
